import { navItems } from "@/mocks/lustCaution";

export default function SiteFooter() {
  const jump = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full bg-primary-950">
      <div className="px-4 md:px-8 py-14 md:py-16">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-primary-950">
                <i className="ri-film-line text-base" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50 tracking-wide">
                色，戒 · 版本档案
              </span>
            </div>
            <p className="mt-4 text-background-200/70 text-sm leading-relaxed max-w-sm">
              一个专注于《色，戒》版本差异与剧情解析的内容页面。所有内容以公开资料与影片本身为基础整理，仅供影迷参考交流。
            </p>
          </div>

          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-2">
            {navItems.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => jump(item.id)}
                className="text-left text-sm text-background-200/75 hover:text-accent-400 transition-colors py-1.5 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-200/50 text-xs">
            © 2026 色戒未删减版 · 版本档案 — 内容仅供影视评论参考
          </p>
          <p className="text-background-200/50 text-xs">含成人内容，请成年观众在合适环境下阅读</p>
        </div>
      </div>
    </footer>
  );
}